import React from "react";

import Magazine from "../Magazine/Magazine";
import Newsletter from "../Newsletter/Newsletter";

const ModuleBlogNewsletter = ({
  hasBlog,
  uiVariantBlogNewsletter,
  posts,
  primaryColor,
  home,
}) => {
  return (
    <div className="container">
      <div className="row">
        {!!hasBlog && posts.length > 0 && (
          <div
            className={`${
              uiVariantBlogNewsletter === "3" ? "col-lg-12" : "col-lg-8"
            }`}
          >
            <Magazine
              posts={posts}
              primaryColor={primaryColor}
              uiVariantBlogNewsletter={uiVariantBlogNewsletter}
            />
          </div>
        )}
        <div
          className={`${
            !!hasBlog && posts.length > 0 && uiVariantBlogNewsletter !== "3"
              ? "col-lg-4"
              : "col-sm-12"
          }`}
        >
          <Newsletter
            primaryColor={primaryColor}
            newsletterTitle={home.newsletterTitle}
            isFullWidth={
              !hasBlog || posts.length < 1 || uiVariantBlogNewsletter === "3"
            }
            uiVariantBlogNewsletter={uiVariantBlogNewsletter}
          />
        </div>
      </div>
    </div>
  );
};

export default ModuleBlogNewsletter;
